import { ICronJob } from '../../models/ICronJob';
import { api } from './api';
import { CreateCronJobRequest, UpdateCronJobActiveRequest, UpdateCronJobRequest } from './types';

export const cronJobsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getAllCronJobs: build.query<ICronJob[], void>({
            query: () => ({ url: '/cron-jobs/get-all' }),
            providesTags: ['CronJob'],
        }),
        createCronJob: build.mutation<ICronJob, CreateCronJobRequest>({
            query: (body: CreateCronJobRequest) => ({
                url: '/cron-jobs/create',
                method: 'POST',
                body,
                credentials: 'include',
            }),
            invalidatesTags: (result, error) => error ? [] : ['CronJob'],
        }),
        updateCronJob: build.mutation<ICronJob, UpdateCronJobRequest>({
            query: (body: UpdateCronJobRequest) => ({
                url: '/cron-jobs/update',
                method: 'POST',
                body,
                credentials: 'include',
            }),
            invalidatesTags: (result, error) => error ? [] : ['CronJob'],
        }),
        updateCronJobActive: build.mutation<ICronJob, UpdateCronJobActiveRequest>({
            query: (body: UpdateCronJobActiveRequest) => ({
                url: '/cron-jobs/update-active',
                method: 'POST',
                body,
                credentials: 'include',
            }),
            invalidatesTags: (result, error) => error ? [] : ['CronJob'],
        }),
        deleteCronJob: build.mutation<{ success: boolean }, string>({
            query: (id: string) => ({
                url: `/cron-jobs/${id}`,
                method: 'DELETE',
                credentials: 'include',
            }),
            invalidatesTags: (result, error) => error ? [] : ['CronJob'],
        }),
    })
})

export const {
    useGetAllCronJobsQuery,
    useCreateCronJobMutation,
    useUpdateCronJobMutation,
    useUpdateCronJobActiveMutation,
    useDeleteCronJobMutation,
} = cronJobsApi
